/**
 * MODULE: domain/sales-opportunities/frontend/components/chat/OpportunityCreatedCard.tsx
 * PURPOSE: Generative UI card after assistant creates an opportunity
 *
 * AGENT SAFETY: SAFE
 */

import React from 'react';
import { Link } from 'react-router-dom';

export interface OpportunityCreatedData {
  id: string;
  name: string;
  account_name: string;
  stage: string;
  value: string | null;
  currency: string;
  status: string;
}

export interface OpportunityCreatedCardProps {
  data: OpportunityCreatedData;
  onViewOpportunity?: (id: string) => void;
}

export const OpportunityCreatedCard: React.FC<OpportunityCreatedCardProps> = ({
  data,
  onViewOpportunity,
}) => {
  const valueNum = data.value != null && data.value !== '' ? parseFloat(data.value) : NaN;

  return (
    <div className="mt-2 max-w-sm rounded-xl border border-green-200 bg-green-50 p-4 shadow-sm dark:border-green-800 dark:bg-green-950/30">
      <div className="mb-3 flex items-center gap-2">
        <div className="h-2 w-2 rounded-full bg-green-500" />
        <span className="text-xs font-semibold uppercase tracking-wide text-green-700 dark:text-green-400">
          Opportunity created
        </span>
      </div>

      <div className="space-y-1.5">
        <div>
          <p className="text-sm font-semibold text-gray-900 dark:text-white">{data.name}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400">{data.account_name}</p>
        </div>

        <div className="flex flex-wrap gap-3 text-xs text-gray-600 dark:text-gray-300">
          <span className="rounded-full bg-blue-100 px-2 py-0.5 font-medium text-blue-700 dark:bg-blue-900/40 dark:text-blue-200">
            {data.stage}
          </span>
          {!Number.isNaN(valueNum) && (
            <span className="font-medium">
              {data.currency} {valueNum.toLocaleString()}
            </span>
          )}
        </div>
      </div>

      {onViewOpportunity ? (
        <button
          type="button"
          onClick={() => onViewOpportunity(data.id)}
          className="mt-3 w-full rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-blue-700"
        >
          View opportunity →
        </button>
      ) : (
        <Link
          to={`/deals/${data.id}`}
          className="mt-3 flex w-full items-center justify-center rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-blue-700"
        >
          View opportunity →
        </Link>
      )}
    </div>
  );
};
